"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importStar(require("react"));
const react_hanger_1 = require("react-hanger");
const react_loops_1 = require("react-loops");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const Button_1 = tslib_1.__importDefault(require("reactstrap/lib/Button"));
const context_1 = require("../../../../context");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../../graphql");
const utils_1 = require("../../../../utils");
const NewEmailView_1 = require("./NewEmailView");
const react_router_dom_1 = require("react-router-dom");
exports.EmailHome = () => {
    const { currentUser, currentWorkspace } = react_1.useContext(context_1.OsmosysAppContext);
    const [showAssignedEmails, toggleShowAssignedEmails] = react_use_1.useToggle(true);
    const { state } = react_hanger_1.useSetState({
        emailTemplate: null,
        emailTemplateVersion: null,
    });
    const history = react_router_dom_1.useHistory();
    return (react_1.default.createElement(react_2.OsmosysListLayout, { itemProps: (item) => {
            return {
                icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faEnvelopeOpen, size: "4x" }),
                iconLabel: 'Email',
                linkURL: `/emails/${item.emailNumber}`,
                meta: (react_1.default.createElement("div", { className: "flex-row" },
                    react_1.default.createElement(react_loops_1.For, { of: item.assignedUsers }, user => {
                        return (react_1.default.createElement("div", { className: "mr-2" },
                            react_1.default.createElement(react_2.OsmosysTooltip, { label: user.email },
                                react_1.default.createElement(react_2.OsmosysDiv, null,
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUser, className: "mr-1" }),
                                    ' ',
                                    user.fullName || user.email))));
                    }))),
                title: item && item.name
                    ? item.name
                    : `Email #${item.emailNumber || item.id}`,
            };
        }, pathToCount: "emailsCount", pathToItems: "emails", pathToLabel: "name", pathToName: "name", itemName: "email", itemsName: "emails", resource: "Email", toolbarLeft: () => (react_1.default.createElement("div", null,
            react_1.default.createElement(NewEmailView_1.NewEmailView, null))), toolbarRight: () => {
            var _a;
            return (react_1.default.createElement(reactstrap_1.ButtonGroup, null,
                react_1.default.createElement(Button_1.default, { outline: !showAssignedEmails, color: "primary", className: utils_1.classnames(showAssignedEmails && 'text-underline'), onClick: () => {
                        window.blur();
                        toggleShowAssignedEmails(true);
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUser, className: "mr-2" }),
                    ((_a = currentUser) === null || _a === void 0 ? void 0 : _a.fullName) ? currentUser.fullName : 'My',
                    " emails"),
                react_1.default.createElement(Button_1.default, { outline: showAssignedEmails, color: "primary", className: utils_1.classnames(!showAssignedEmails && 'text-underline'), onClick: () => {
                        window.blur();
                        toggleShowAssignedEmails(false);
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUsers, className: "mr-2" }),
                    currentWorkspace && currentWorkspace.name,
                    " emails")));
        }, query: {
            query: graphql_1.emails,
            variables: Object.assign(Object.assign({}, state), { assignedEmails: showAssignedEmails === true }),
        } }));
};
exports.default = exports.EmailHome;
//# sourceMappingURL=index.js.map